import React from 'react'
import { DatePicker } from 'meinian-package/src/component'
import UserSelect from 'view/components/userSelect'
import Platform from 'component/filter/platform'
import Mark from 'component/filter/mark'
import GenderAndCategory from 'component/filter/genderAndCategory/newCategory'
import { getMeinianFilters } from 'common/localData'
import { getMatrix } from 'component/util'
import { PLATFORM_VALUE } from 'meinian-package/src/component/enum'

type TAanalysisFilter = {
    value: any,
    onChange:(val:any)=>void,
    inspirationId?:string|number,
    needMarkTimes?:string|number,
    authAdmin:boolean
}

export default ({ value, onChange, inspirationId, needMarkTimes, authAdmin }:TAanalysisFilter) => {
  const changeGenderAndCategory = (gender, category) => {
    const _params = {
      labelMatrix: []
    }
    if (category) {
      const filters = getMeinianFilters()
      const matrix = getMatrix(category, filters.find(m => m.itemName === '品类'))
      _params.labelMatrix = [..._params.labelMatrix, matrix]
    }
    onChange({ gender, category, ..._params })
  }
  return <div className="df-center">
    {
      authAdmin && <UserSelect
        trigger="click"
        placeholder="所有人"
        container={document.body}
        value={value?.userId}
        onChange={value => {
          onChange({ userId: value })
        }}
        inspirationId={inspirationId}
      />
    }
    <Platform
      trigger="click"
      value={value?.platformId}
      onChange={(val) => onChange({ platformId: val })}
    />
    <GenderAndCategory
      label={null}
      overlayStyle={{ minWidth: '540px' }}
      placement="bottomRight"
      displayStyle={{ padding: '5px 8px' }}
      placeholder="所属品类"
      gender={value.gender}
      value={value.category}
      onChange={(cur, root) => {
        if (cur === root) {
          changeGenderAndCategory(root, null)
        } else {
          changeGenderAndCategory(root, cur)
        }
      }}
      shopStatus={value.platformId == PLATFORM_VALUE.ITEM ? 1 : 0}
    />
    <DatePicker
      style={{ padding: '5px 8px' }}
      startTime={value.startTime}
      endTime={value.endTime}
      noneText="采集时间"
      onChange={([startTime, endTime]) => onChange({ startTime, endTime })}
    />
    <Mark
      trigger="click"
      value={value.markStatus}
      otherValue={value.markTimes}
      inspirationId={inspirationId}
      needMarkTimes={needMarkTimes}
      onChange={(markStatus, item) => onChange({ markStatus, markTimes: item?.markTimes })}
    />
  </div>
}
